<script setup>
import { computed } from 'vue';

const props = defineProps({
  conversation: { type: Object, required: true },
});

const post = computed(() => props.conversation?.additional_attributes || {});
</script>

<template>
  <div class="mt-2 flex flex-col gap-1.5 text-xs">
    <div
      class="flex items-center gap-1.5 rounded-md bg-n-slate-9/10 py-1 ps-2 pe-2 text-n-slate-11"
    >
      <span class="i-lucide-linkedin size-3.5 flex-shrink-0" />
      <span class="truncate flex-grow">
        {{ $t('CONVERSATION.LINKEDIN_COMMENT.ON_POST') }}
        <span class="text-n-slate-12">
          {{
            post.post_message ||
            $t('CONVERSATION.LINKEDIN_COMMENT.UNTITLED_POST')
          }}
        </span>
      </span>
      <a
        v-if="post.post_permalink_url"
        :href="post.post_permalink_url"
        target="_blank"
        rel="noopener noreferrer"
        class="flex-shrink-0 text-n-blue-text hover:underline"
      >
        {{ $t('CONVERSATION.LINKEDIN_COMMENT.VIEW_POST') }}
      </a>
    </div>
    <span class="text-n-slate-11">
      {{ $t('CONVERSATION.LINKEDIN_COMMENT.HINT') }}
    </span>
  </div>
</template>
